import './InteractTray.scss';
import { Tray } from '../Tray';

export function InteractTray() {
  return <Tray />;
}
